import { ButtonCopyTextToClipboard } from "components/button/ButtonCopyTextToClipboard";
import { useProduct } from "contexts/ProductContext";
import { useTranslation } from "react-i18next";
import { useBookDescription } from "contexts/BookDescriptionContext";
import { BasePanel } from "components/BasePanel";
import { getDescription } from "reedy-data";
import { EmptyText } from "components/empty/EmptyText";
import {
  getKeywordsByType,
  keywordsToText,
} from "integrations/firebase/collections";
import { Editor } from "../Editor";

export const DatabaseDescription = () => {
  const { t } = useTranslation(["productDetails"]);
  const { product } = useProduct();
  const { selectedDescriptionHash, handleCopyDoneDatabaseBookDescription } =
    useBookDescription();
  const { final } = getKeywordsByType(product);

  const selectedDescription = getDescription(product, selectedDescriptionHash);
  const bookDescription = selectedDescription?.text;

  const keywords = {
    final: keywordsToText(final),
  };

  return (
    <BasePanel
      title={t(
        "productDetails:bookDescription.tabDatabase.databaseBookDescription",
      )}
      isEmpty={!bookDescription}
      emptyComponent={
        <EmptyText
          title={t("productDetails:bookDescription.tabDatabase.empty.header")}
          text={t("productDetails:bookDescription.tabDatabase.empty.message")}
          variant="dark"
        />
      }
      className="h-(--subject-list-container-height)"
      wrapper={false}
      headerAction={
        bookDescription && (
          <ButtonCopyTextToClipboard
            textToCopy={bookDescription}
            tooltipText={t("general:tooltips.copyToClipboard")}
            onDone={handleCopyDoneDatabaseBookDescription}
            buttonText={t("general:buttons.copy")}
          />
        )
      }
      border={false}
    >
      {bookDescription && (
        <Editor
          unescapeHtml
          key={`${product?.id}-${selectedDescriptionHash}`}
          className="h-[calc(100%-48px)]"
          initialValue={bookDescription}
          keywords={keywords}
          disabled
        />
      )}
    </BasePanel>
  );
};
